// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__FtZBT","title":"Header_title__53are","left":"Header_left__1p1qd","clinicName":"Header_clinicName__b4385"};